
import React, {FC} from 'react';
import {NavProps} from 'components/Header';
import {Link} from 'components/Header/navs';
import {Link as GatsbyLink} from 'gatsby';
import {navigate} from 'gatsby';

import * as styles from './styles.module.scss';

export const handleClick = (nav: NavProps['nav'], target: string) => (
	(e: React.MouseEvent) => {
		if ((location.pathname + location.hash) === target) {
			if (nav.active) {
				nav.close();
				e.stopPropagation();
				return;
			}

			// This branch is called if we're
			// clicking the hover-only menu
			//
			// navigate(0) triggers a full reload
			//
			// This is really pretty inefficient
			// but there doesn't seem to be another easy
			// close the hover menu

			window.location.replace(window.location.href);
			return;
		}

		navigate(target);
	}
);

type LinkProps = NavProps & {
	link: Link
}

const _Link: FC<LinkProps> = ({nav, link}) => {
	return (
		<GatsbyLink className={styles.link} to={link.link} onClick={handleClick(nav, link.link)}>
			{link.text}
		</GatsbyLink>
	);
};

export default _Link;
